import apiPesanan from '@/api/seller/pesanan';

const defaultState = () => ({
	statusPesanan: null,
	historyTrackingData: [],
	pesananData: [],
	pesananNewData: [],
	pesananPaidData: [],
	loadPesanan: false,
	detailPesanan: {},
	detailAlamat: {},
	pesananPagination: '',
	pesananNewPagination: '',
	response: {
		code: '',
		message: ''
	},
	responseError: {},
	alertMultiple: [],
	alert: ''
});

const state = defaultState();

const getters = {};

const mutations = {
	setHistoryTracking(state, data) {
		state.historyTrackingData = data.data
	},
	setStatus(state, data) {
		state.statusPesanan = data.data
	},
	setPesanan(state, data) {
		state.pesananData = data.data
		state.pesananPagination = data.pagination
	},
	setPaidPesanan(state, data) {
		state.pesananPaidData = data.data
		state.pesananPagination = data.pagination
	},
	setNewPesanan(state, data) {
		state.pesananNewData = data.data
		state.pesananNewPagination = data.pagination
	},
	setloadPesanan(state, data) {
		state.loadPesanan = data
	},
	setPesananDetail(state, data) {
		state.detailPesanan = data
	},
	setAlamatDetail(state, data) {
		state.detailAlamat = data
	},
	saveResponse(state, data) {
		state.response = data
		state.alertMultiple = []
		state.responseError = {}
		state.alert = ''
	},
	validationError(state, data) {
		state.responseError = data
	},
	multipleAlert(state, data) {
		state.alertMultiple = data.map((el) => {
			return {
				show: true,
				message: el
			}
		})
	},
	failed(state, data) {
		state.alert = data
	},
	clearPesanan(state) {
		Object.assign(state, defaultState());
	}
};

const actions = {
	getHistoryTracking({ commit }, params) {
		commit('setloadPesanan', true);
		return new Promise((resolve) => {
			apiPesanan.getHistoryTracking(params).then(({ data: { data } }) => {
				commit('setHistoryTracking', { data: data.results });
				resolve(true);
			}).then(() => {
				commit('setloadPesanan', false);
			});
		});
	},
	getTrackingKiriminaja({ commit }, params) {
		commit('setloadPesanan', true);
		return new Promise((resolve) => {
			apiPesanan.getTrackingKiriminaja(params).then(({ data: { data } }) => {
				// commit('setPesanan', { data: data.results, pagination: data.pagination });
				resolve(true);
			}).then(() => {
				commit('setloadPesanan', false);
			});
		});
	},
	getTracking({ commit }, params) {
		commit('setloadPesanan', true);
		return new Promise((resolve) => {
			apiPesanan.getTracking(params).then(({ data: { data } }) => {
				// commit('setPesanan', { data: data.results, pagination: data.pagination });
				resolve(true);
			}).then(() => {
				commit('setloadPesanan', false);
			});
		});
	},
	getStatusPesanan({ commit }, params) {
		return new Promise((resolve) => {
			apiPesanan.getStatusPesanan(params).then(({ data: { data } }) => {
				commit('setStatus', { data: data.results });
				resolve(true);
			}).catch(() => {
				commit('setStatus', { data: [] });
			}).then(() => {

			});
		});
	},

	getPesanan({ commit }, params) {
		commit('setloadPesanan', true);
		return new Promise((resolve) => {
			apiPesanan.getPesanan(params).then(({ data: { data } }) => {
				commit('setPesanan', { data: data.results, pagination: data.pagination });
				resolve(true);
			}).catch(() => {
				commit('setPesanan', { data: [], pagination: {} });
			}).then(() => {
				commit('setloadPesanan', false);
			});
		});
	},

	getPaidPesanan({ commit }, params) {
		commit('setloadPesanan', true);
		return new Promise((resolve) => {
			apiPesanan.getPaidPesanan(params).then(({ data: { data } }) => {
				commit('setPaidPesanan', { data: data.results, pagination: data.pagination });
				resolve(true);
			}).catch(() => {
				commit('setPaidPesanan', { data: [], pagination: {} });
			}).then(() => {
				commit('setloadPesanan', false);
			});
		});
	},

	getNewPesanan({ commit }, params) {
		commit('setloadPesanan', true);
		return new Promise((resolve) => {
			apiPesanan.getPesanan(params).then(({ data: { data } }) => {
				commit('setNewPesanan', { data: data.results, pagination: data.pagination });
				resolve(true);
			}).catch(() => {
				commit('setNewPesanan', { data: [], pagination: {} });
			}).then(() => {
				commit('setloadPesanan', false);
			});
		});
	},

	getPesananDetail({ commit }, params) {
		commit('setloadPesanan', true);
		return new Promise((resolve) => {
			apiPesanan.getPesananDetail(params).then(({ data: { data } }) => {
				commit('setPesananDetail', data.results);
				resolve(true);
			}).catch(() => {
				commit('setPesananDetail', {});
			}).then(() => {
				commit('setloadPesanan', false);
			});
		});
	},
	getPesananDetailShipment({ commit }, params) {
		commit('setloadPesanan', true);
		return new Promise((resolve) => {
			apiPesanan.getPesananDetailShipment(params).then(({ data: { data } }) => {
				commit('setPesananDetail', data.results);
				resolve(true);
			}).catch(() => {
				commit('setPesananDetail', {});
			}).then(() => {
				commit('setloadPesanan', false);
			});
		});
	},
	
	getAlamatDetail({ commit }, params) {
		return new Promise((resolve) => {
			apiPesanan.getAlamatDetail(params).then(({ data: { data } }) => {
				commit('setAlamatDetail', data.results);
				resolve(true);
			}).catch(() => {
				commit('setAlamatDetail', {});
			})
		});
	},
	prosesPesanan({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiPesanan.prosesPesanan(params).then((data) => {
				dispatch('success', data.data)
				resolve(true);
			}).catch((err) => {
				reject(true)
				const { data } = err.response;
				dispatch('errorHandler', data);
			})
		});
	},
	kirimPesanan({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiPesanan.kirimPesanan(params).then((data) => {
				dispatch('success', data.data)
				resolve(true);
			}).catch((err) => {
				reject(true)
				const { data } = err.response;
				dispatch('errorHandler', data);
			})
		});
	},
	paymentStorePaid({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiPesanan.paymentStorePaid(params).then((data) => {
				dispatch('success', data.data)
				resolve(true);
			}).catch((err) => {
				reject(true)
				const { data } = err.response;
				dispatch('errorHandler', data);
			})
		});
	},
	paymentStoreCancel({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiPesanan.paymentStoreCancel(params).then((data) => {
				dispatch('success', data.data)
				resolve(true);
			}).catch((err) => {
				reject(true)
				const { data } = err.response;
				dispatch('errorHandler', data);
			})
		});
	},
	cancelPesanan({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiPesanan.cancelPesanan(params).then((data) => {
				dispatch('success', data.data)
				resolve(true);
			}).catch((err) => {
				reject(true)
				const { data } = err.response;
				dispatch('errorHandler', data);
			})
		});
	},
	requestPickupPesanan({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiPesanan.requestPickupPesanan(params).then((data) => {
				dispatch('success', data.data)
				resolve(true);
			}).catch((err) => {
				reject(true)
				const { data } = err.response;
				dispatch('errorHandler', data);
			})
		});
	},
	pickupStore({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiPesanan.pickupStore(params).then((data) => {
				dispatch('success', data.data)
				resolve(true);
			}).catch((err) => {
				reject(true)
				const { data } = err.response;
				dispatch('errorHandler', data);
			})
		});
	},
	changeResi({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiPesanan.changeResi(params).then((data) => {
				dispatch('success', data.data)
				resolve(true);
			}).catch((err) => {
				reject(true)
				const { data } = err.response;
				dispatch('errorHandler', data);
			})
		});
	},
	success({ commit }, response) {
		commit('saveResponse', response)
	},
	errorHandler({ commit }, response) {
		switch (response.message) {
			case 'error_validation':
				commit('validationError', response.data);
				break;

			case 'error_multiple_alert':
				commit('multipleAlert', response.data.error)
				break;

			default:
				commit('makeAlert', { code: 'error_response', type: 'error', message: response.message, show: true }, { root: true });
				break;
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};